import { type AggResponse } from '../../../common/utils/fetch-agg';
import { inMemoryCache } from '../../../utils/caching/in-memory';
import type { KnowledgeDiscoverySearchChatIntentDetectionResponse } from './types';

type SearchChatIntentDetectionResponse =
	AggResponse<KnowledgeDiscoverySearchChatIntentDetectionResponse>;

/**
 * In-memory cache for Search/Chat intent detection responses.
 *
 * Pending promises are shared by callers with the same cache key. Successful responses remain
 * available for the default cache TTL, while rejected entries are cleared so failures can retry.
 */
const searchChatIntentDetectionCache = inMemoryCache<SearchChatIntentDetectionResponse>();

export const getCachedSearchChatIntentDetectionResponse = async (
	key: string,
	supplier: () => Promise<SearchChatIntentDetectionResponse>,
): Promise<SearchChatIntentDetectionResponse> =>
	searchChatIntentDetectionCache.inMemoryDecorator(key, supplier);

export const clearSearchChatIntentDetectionCache = (key?: string): void => {
	searchChatIntentDetectionCache.clear(key);
};
